<template>
  <div class="c-columns gap-x-5 gap-y-16 font-rubik">
    <div v-for="{list, name, text} in propList" :key="name" class="c-columns__column">
      <div class="pb-2 text-lg text-black leading-7">{{ text }}</div>
      <router-link
        v-for="{text, value} in (list)"
        :key="value"
        :to="value"
        class="block pb-2"
      >
        {{ text }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { props } from './props'
import { computed } from 'vue'
import List from 'dcode/classes/List'

export default {
  name: 'CColumns',
  props,
  setup (props) {
    const propList = computed(() => new List(props.list).get())

    return {
      propList
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
